import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    pagination: {
      page: 1,
      size: 25
    },
    datas: [],
   
    totalCount: 0,
    detail: null,
    coinTypes: []
  },
  getters: {
    list: state => {
      return state.datas.map(item => ({
        ...item
      }));
    }
  },
  mutations: {
    setCoinTypes(state, payload) {
      state.coinTypes = payload;
    },
    setList(state, payload) {
      state.datas = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setDetail(state, payload) {
      state.detail = payload;
    },
   
  },
  actions: {
   
    updateOne({ commit },payload) {
     return api.updateOne(payload).then((res) => {
       return res
      });
    },
    reqList({ commit }, query) {
      api.reqList(query).then((res) => {
        commit('setList', res.data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    create(context, data) {
      return api.create(data);
    },
    remove(context, confKey) {
      return api.del(confKey).then(res=>{
        return res
      });
    }
  }
};

appStore.registerModule('Siteconf', store);
